import { OPEN_MODAL } from '../actionTypes';
import { configurationDocumentsActions } from '../reducer';

export default (value) => configurationDocumentsActions[OPEN_MODAL](value);
